import { Grid, Hidden } from "@mui/material"
import { ISettingsItem } from "../../../Settings"
import { usePlan } from '../../../Plans'
import { useTranslation } from '../../../i18n'
import { ReactComponent as WhatsappIcon } from '../../../assets/icons/whatsappIcon.svg'
import { ReactComponent as PhoneIcon } from '../../../assets/icons/phoneIcon.svg'
import { ReactComponent as RefreshIcon } from '../../../assets/icons/refreshIcon.svg'
import { ReactComponent as CellTowerIcon } from '../../../assets/icons/cellTower.svg'
import { ReactComponent as CheckIcon } from '../../../assets/icons/checkIcon.svg'
import { ReactComponent as CoverageIcon } from '../../../assets/icons/coverage.svg'
import { ReactComponent as WazeIcon } from '../../../assets/icons/wazeIcon.svg'

export default function PlanDetailsText({ name, variables }: ISettingsItem) {
  const { currentPlan } = usePlan()
  const { t } = useTranslation()
  const { text } = variables || {}

  const ligacoes = currentPlan.ligacoes === 'ligações ilimitadas' ? t.page1.planDetails.callsUnlimited : t.page1.planDetails.callsLimited
  const defaultTextArray = [
    t.page1.planDetails.whatsapp,
    ligacoes,
    t.page1.planDetails.net5G,
    t.page1.planDetails.internetAccumulate,
    `${currentPlan.plano} ${t.page1.planDetails.noCutsSuffix}`,
    t.page1.planDetails.nationalCoverage,
  ]

  const mobileTextArray = [
    t.page1.planDetails.mobileIncluded,
    t.page1.planDetails.net5G,
    t.page1.planDetails.mobileTechnology,
    t.page1.planDetails.mobileAccumulate,
    t.page1.planDetails.mobileInternetAccumulation,
    t.page1.planDetails.mobileNoCuts,
    t.page1.planDetails.mobileInternet,
    t.page1.planDetails.mobileBonus,
    t.page1.planDetails.mobileMonth,
  ]

  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== '' ? value : defaultTextArray[index]))
    : defaultTextArray

  return (
    <Grid container item className={name ? `${name} plan-details-text` : "plan-details-text"} xs={12}>
      <Hidden mdUp>
        <h3>{mobileTextArray[0]}</h3>
        <ul>
          <li>
            <h3>{mobileTextArray[1]}</h3>
            <p>{mobileTextArray[2]}</p>
          </li>
          <li>
            <h3>{mobileTextArray[3]}</h3>
            <p>{mobileTextArray[4]}</p>
          </li>
          <li>
            <h3>{mobileTextArray[5]}</h3>
            <p>{mobileTextArray[6]}</p>
          </li>
          <li className="plan-details-text-bonus">
            <h3>{mobileTextArray[7]}</h3>
            <p>{mobileTextArray[8]}</p>
          </li>
        </ul>
      </Hidden>
      <Hidden mdDown>
        <Grid item className="planDetailsTextColumn planDetailsTextLeft" xs={12} md={6} rowGap={1}>
          <div className="planDetailsTextDetail icon">
            <WhatsappIcon />
            <p>{mergedArray[0]}</p>
          </div>
          <div className="planDetailsTextDetail icon">
            <PhoneIcon />
            <p>{mergedArray[1]}</p>
          </div>
          <div className="planDetailsTextDetail cellTowerIcon">
            <CellTowerIcon />
            <p>{mergedArray[2]}</p>
          </div>
          {currentPlan.aplicativos.includes(' Waze') && (
            <div className="planDetailsTextDetail icon">
              <WazeIcon />
              <p>{t.page1.planDetails.wazeUnlimited}</p>
            </div>
          )}
        </Grid>
        <Grid item className="planDetailsTextColumn planDetailsTextRight" xs={12} md={6} rowGap={3}>
          <div className="planDetailsTextDetail icon">
            <RefreshIcon />
            <p>{mergedArray[3]}</p>
          </div>
          <div className="planDetailsTextDetail checkIcon">
            <CheckIcon />
            <p>{mergedArray[4]}</p>
          </div>
          <div className="planDetailsTextDetail icon">
            <CoverageIcon />
            <p>{mergedArray[5]}</p>
          </div>
        </Grid>
      </Hidden>
    </Grid>
  )
}
